const defaultState = false;

export const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_PROCUREMENT_ITEM_SUBMITTING':
      return action.submitting;
    default:
      return state;
  }
};
